import { useContext } from 'react';
import { Box, Flex, Image } from 'src/components/ui';
import { Link } from 'react-router-dom';

import Logo from 'src/assets/svgs/logo.svg';
import UserAvatar from 'src/components/common/UserAvatar';
import UserContext from 'src/contexts/user/UserContext';

const Header = () => {
	const { user } = useContext(UserContext);

	const shouldShowAvatar = user && !user.permissions?.includes('demoByDomain');

	return (
		<Box h="71px" p="15px 20px" shadow="0px 2px 2px -1px rgba(0, 0, 0, 0.15)">
			<Flex justifyContent="space-between" alignItems="center">
				<Link to="https://www.fusionos.ai">
					<Image src={Logo} height="30px" />
				</Link>
				{shouldShowAvatar && <UserAvatar name={user.name} />}
			</Flex>
		</Box>
	);
};

export default Header;
